<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="150px" :model="form" :rules="rules">
        <el-form-item label="小程序链接" v-if="!!form.sheetId">
          <span ref='path'>{{ `form/index/index?sheetId=${form.sheetId}` }}</span> <el-button type="primary" class="ml-10" @click="copy" size="mini" plain>复制</el-button>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model.trim="form.title" placeholder="请输入标题" class="fix-width" />
        </el-form-item>
        <el-form-item label="最大填写次数" prop="maxSubmitCount">
          <el-input-number v-model="form.maxSubmitCount" placeholder="请输入单人最大可填写次数，0表示不限，选填" />
          单人最大可填写次数，0表示不限，选填
        </el-form-item>
        <el-form-item label="说明" prop="text">
          <el-input
            v-model.trim="form.text"
            type="textarea"
             class="fix-width"
            placeholder="请输入说明，选填"
          />
        </el-form-item>
        <el-form-item label="问题列表">
          <el-button type="primary" size="mini" class= "mb-10" @click="addQuestion(null)">
            增加
          </el-button>
          <el-table stripe :data="form.questionList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="标题"
              prop="title"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="类型"
              prop="typehood"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                {{ questionRegFormTypehood[row.typehood - 1].value }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="是否必填"
              prop="flag"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <el-tag v-if="row.flag == 1">必填</el-tag>
                <el-tag v-if="row.flag == 2">选填</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="选项列表"
              prop="options"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <el-tag v-for="(item, index) of row.options" :key="index">
                  {{ item }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="140px"
            >
              <template #default="{ row, $index }">
                <el-button type="text" @click="addQuestion(row, $index)">
                  修改
                </el-button>
                <el-button type="text" @click="qHandleDelete($index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="提交提示" prop="tips">
          <el-input
            v-model.trim="form.tips"
            placeholder="请输入提交提示，选填"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="隐私声明标题" prop="agreementTitle">
          <el-input
            v-model.trim="form.agreementTitle"
            placeholder="请输入隐私声明标题，选填"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="隐私声明附加标题" prop="agreementTitleEx">
          <el-input
            v-model.trim="form.agreementTitleEx"
            placeholder="请输入隐私声明附加标题，选填"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="隐私声明内容" prop="agreementText">
          <el-input
            type="textarea"
            :rows="5"
            v-model.trim="form.agreementText"
            placeholder="请输入隐私声明内容，选填"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      v-model="questionFormVisible"
      :title="questionTitle"
      width="800px"
      @close="questionClose"
    >
      <el-form
        ref="questionForm"
        label-width="80px"
        :model="questionForm"
        :rules="questionFormRules"
      >
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="questionForm.title"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="类型" prop="typehood">
          <el-select v-model="questionForm.typehood" placeholder="请选择类型">
            <el-option
              v-for="item in questionRegFormTypehood"
              :key="item.type"
              :label="item.value"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必填" prop="flag">
          <el-radio v-model="questionForm.flag" :label="1">必填</el-radio>
          <el-radio v-model="questionForm.flag" :label="2">选填</el-radio>
        </el-form-item>
        <el-form-item label="选项列表" prop="options">
          <el-select
            style="width: 100%"
            v-model="questionForm.options"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请输入选项(输入后按Enter键)"
          ></el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="questionClose">取 消</el-button>
        <el-button type="primary" @click="questionSave">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { sheetCreate, sheetUpdate } from '@/api/questionRegForm'
import { questionRegFormTypehood } from '@/utils/const'
export default {
  name: 'QuestionRegFormEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      questionTitle: '',
      questionRegFormTypehood,
      form: {
        sheetId: '',
        title: '',
        maxSubmitCount: 0,
        text: '',
        questionList: [],
        tips: '',
        agreementTitle: '',
        agreementTitleEx: '',
        agreementText: '',
        order: 1,
      },
      questionForm: {
        index: null,
        title: '',
        typehood: 1,
        flag: 2,
        options: [],
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        typehood: [{ required: true }],
        flag: [{ flag: true }],
      },
      questionFormRules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        options: [
          {
            validator: (rule, value, callback) => {
              if (
                value.length == 0 &&
                (this.questionForm.typehood == 1 ||
                  this.questionForm.typehood == 2)
              ) {
                callback(new Error('请填写问题选项'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false,
      questionFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改表单'
        this.form = Object.assign(this.form, row.basic)
        this.form.title = row.title
        this.form.sheetId = row.sheetId
      } else {
        this.title = '新增表单'
      }
      this.dialogFormVisible = true
    },
    copy() {
      const text = this.$refs.path.innerHTML
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
    qHandleDelete(index) {
      this.form.questionList.splice(index, 1)
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    questionClose() {
      this.$refs['questionForm'].resetFields()
      this.questionForm = this.$options.data().questionForm
      this.questionFormVisible = false
    },
    addQuestion(row, index) {
      if (row) {
        this.questionTitle = '编辑问题'
        this.questionForm = Object.assign(this.questionForm, row)
        this.questionForm.index = index
      } else {
        this.questionTitle = '新增问题'
      }
      this.questionFormVisible = true
    },
    questionSave() {
      this.$refs['questionForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.questionForm)
          console.log(form)
          const index = form.index
          if (form.typehood !== 1 && form.typehood !== 2) {
            form.options = []
          }
          delete form.index
          if (index != null) {
            this.form.questionList.splice(index, 1, form)
          } else {
            this.form.questionList.push(form)
          }
          this.questionClose()
        } else {
          return false
        }
      })
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const sheetId = this.form.sheetId
          this.$baseConfirm(
            `你确定要${sheetId ? '修改' : '新增'}表单吗`,
            null,
            async () => {
              sheetId
                ? await sheetUpdate(this.form)
                : await sheetCreate(this.form)
              this.$baseMessage(
                `${sheetId ? '修改' : '新增'}表单成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mb-10 {
  margin-bottom: 10px;
}
.fix-width {
  width: 500px;
}
.ml-10 {
  margin-left: 10px;
}
</style>
